import { JSX } from "react";

export function Maintenance(): JSX.Element {
  return <div>Maintenance</div>;
}
